<template>
    <div>
        <label>{{label}}</label>
        <input type="text" name="" class="form-control"  v-bind:placeholder="placeholder" v-bind:value="value" v-on:input="$emit('input', $event.target.value)">

        <button class="btn btn-primary full-width" v-on:click="onContinueClick" v-bind:disabled="isOtherExplained">
            {{'Continue'|trans}}
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            label:null,
            value: null,
            placeholder: null
        },
        data() {
            return {
            }
        },
        methods: {
            onContinueClick() {
                // TODO: check length
                this.$emit('continue');
            }
        },
        computed:{
            isOtherExplained(){
                if(this.value){
                    return ((this.value.length < 8))
                }
                return true;
            }
        }
    }
</script>